import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import './ImportAtlasForm.scss';
import getFilesText from '../../../../utils/getFilesText';
import isPhaserAtlas from '../../../../utils/isPhaserAtlas';
import acceptFormatImages from '../../../../constants/acceptFormatImages';
import getImageFiles from '../../../../utils/getImages';
import { useDispatch, useSelector } from 'react-redux';
import {
    SetAtlasImageAnimAction,
    SetAtlasJSONAnimAction,
    ResetAtlasAction,
} from '../../../../Redux/Actions/Animator/atlas.anim.action';
import { AddImage, ImageData } from '../../../../Redux/Actions/Atlas/images.action';
import { RootState } from '../../../../Redux/Store/store';
import { isEmpty } from 'ramda';
import { ObserverAnim, GLOBAL_EVENT_ANIM } from '../../Observer';
import getImagesFromAtlas from '../../../../utils/getImagesFromAtlas';

let isImportComplete = true;

const ImportAtlasForm = () => {
    let open_modal_import_atlas = true;
    const [open_by_state, setOpen_by_state] = useState(false);

    ObserverAnim.removeListener(GLOBAL_EVENT_ANIM.OPEN_ATLAS_IMPORT_MODAL);
    ObserverAnim.on(GLOBAL_EVENT_ANIM.OPEN_ATLAS_IMPORT_MODAL, () => {
        open_modal_import_atlas = true;
        setOpen_by_state(true);
    });

    const atlas_state = useSelector((state: RootState) => state.atlasAnim);
    const dispatch = useDispatch();

    const handleImportImage = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        const files_loaded: any = await getImageFiles(files);
        dispatch(SetAtlasImageAnimAction(files_loaded[0]));
    };

    const handleImportAtlasJSON = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        const files_loaded = await getFilesText(files);

        if (isPhaserAtlas(files_loaded as string)) {
            dispatch(SetAtlasJSONAnimAction(files_loaded as string));
        } else {
            ObserverAnim.emit(GLOBAL_EVENT_ANIM.NOTIFICATION_SYSTEM.ERROR, 'Atlas json incorrect');
        }
    };

    const handleCloseModalByX = () => {
        setOpen_by_state(false);
        dispatch(ResetAtlasAction());
    };

    const is_all_complete = async () => {
        if (
            !isEmpty(atlas_state.image) &&
            !isEmpty(atlas_state.json) &&
            !isImportComplete &&
            isEmpty(atlas_state.animation)
        ) {
            isImportComplete = true;
            const atlas_group = (await getImagesFromAtlas(atlas_state)) as ImageData[];
            setOpen_by_state(false);
            dispatch(AddImage(atlas_group));
        }
        if (isImportComplete) {
            isImportComplete = false;
        }
    };

    is_all_complete();

    return (
        <Modal
            open={open_modal_import_atlas && open_by_state}
            onClose={handleCloseModalByX}
            closeOnOverlayClick={false}
        >
            <h3 className="noselect mt-3 mb-3 mx-5">Import Atlas</h3>
            <div className="import_animate_atlas">
                {isEmpty(atlas_state.image) ? (
                    <button className="fileUpload mb-3">
                        Import Atlas Image
                        <input
                            type="file"
                            className="upload cursor-pointer uploadSprites"
                            onChange={handleImportImage}
                            accept={acceptFormatImages.join(',')}
                        />
                    </button>
                ) : (
                    ''
                )}
                {isEmpty(atlas_state.json) ? (
                    <button className="fileUpload">
                        Import Atlas JSON
                        <input
                            type="file"
                            className="upload cursor-pointer uploadSprites"
                            accept="application/json"
                            onChange={handleImportAtlasJSON}
                        />
                    </button>
                ) : (
                    ''
                )}
            </div>
        </Modal>
    );
};

export default ImportAtlasForm;
